const o = "promptmenu", t = "promptcollect", n = "promptplay", r = "gotoexpert", c = "branch", _ = "goto", O = "assign", s = "customerdata", R = "transfer", E = "hangup", l = {
  [o]: "keypad",
  [t]: "dialer",
  [n]: "volume-2",
  [r]: "expert-node",
  [c]: "branch",
  [_]: "call-merge",
  [O]: "chevrons-right",
  [s]: "list-bullet",
  [R]: "transfer",
  [E]: "phone-hang-up"
}, p = {
  [o]: "Menu",
  [t]: "Collect",
  [n]: "Play",
  [r]: "Expert",
  [c]: "Branch",
  [_]: "Go-to",
  [O]: "Assign",
  [s]: "Customer Data",
  [R]: "Transfer",
  [E]: "Hangup"
}, e = {
  PROMPT: {
    normal: "d-recipe-ivr-node-prompt",
    selected: "d-recipe-ivr-node-prompt--selected"
  },
  LOGIC: {
    normal: "d-recipe-ivr-node-logic",
    selected: "d-recipe-ivr-node-logic--selected"
  },
  TERMINAL: {
    normal: "d-recipe-ivr-node-terminal",
    selected: "d-recipe-ivr-node-terminal--selected"
  }
}, I = {
  [o]: e.PROMPT,
  [t]: e.PROMPT,
  [n]: e.PROMPT,
  [r]: e.LOGIC,
  [c]: e.LOGIC,
  [_]: e.LOGIC,
  [O]: e.LOGIC,
  [s]: e.LOGIC,
  [R]: e.TERMINAL,
  [E]: e.TERMINAL
};
export {
  O as IVR_NODE_ASSIGN,
  c as IVR_NODE_BRANCH,
  I as IVR_NODE_CLASS_MAPPING,
  s as IVR_NODE_CUSTOMER_DATA,
  r as IVR_NODE_EXPERT,
  _ as IVR_NODE_GO_TO,
  E as IVR_NODE_HANGUP,
  l as IVR_NODE_ICON_TYPES,
  p as IVR_NODE_LABELS,
  t as IVR_NODE_PROMPT_COLLECT,
  o as IVR_NODE_PROMPT_MENU,
  n as IVR_NODE_PROMPT_PLAY,
  R as IVR_NODE_TRANSFER
};
//# sourceMappingURL=ivr-node-constants.js.map
